import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaTiktok,  FaTumblr, FaDiscord, FaSun, FaMoon } from 'react-icons/fa';
import UserAppContext from '../../hook/UserAppContext';
import Social from '../buttons/Social'
import './header.css';

const Header = ({isIcon, isSetIcon, isTheme, isSetTheme}) => {

      const {user, data} = UserAppContext()
      const {infordata, banners, social} = user.user;

      const onClickTheme = () => {
            if(isTheme === 'mode_light'){
              localStorage.setItem("theme", "mode_dark");
              isSetTheme(localStorage.getItem('theme'));
              isSetIcon('dark');
            }
            else{
              localStorage.setItem("theme", "mode_light");
              isSetTheme(localStorage.getItem('theme'));
              isSetIcon('light');
            }
            
      }

      const name = infordata.data || infordata.name === '' ? data.info.name : infordata.name
      const avatar = infordata.data || infordata.avatar === '' ? data.info.avatar : infordata.avatar
      const status = infordata.data || infordata.status === '' ? data.info.status : infordata.status
      const about = infordata.data || infordata.about === '' ? data.info.about : infordata.about
      const id_xat = infordata.data || infordata.id_xat === '' ? data.info.id_xat : infordata.id_xat
      const banner = banners.data ? data.banner.image : banners[0].image 
      const banner_title = banners.data ? data.banner.title : banners[0].title

      return (
            <div className="header_content">
                  <div className="header_banner">
                        <div className="banner_content">
                              <img src={banner} alt={banner_title} />
                        </div>
                        <div className="container banner">
                              <h1>{banner_title}</h1>
                              <p>{about}</p>
                              <button className="btn_theme" onClick={() => onClickTheme()}>{(isIcon === 'light') ? <FaSun /> : <FaMoon />}</button>
                        </div>
                  </div>
                  <div className="header_bottom">
                        <div className="container bottom">
                              <div className="header_user">
                                    <div className="user_avatar">
                                          <img src={avatar} alt={name} />
                                    </div>
                                    <div className="user_data">
                                          <h2>{name}</h2>
                                          <span>{id_xat}</span>
                                          <p>{status}</p>
                                    </div>
                              </div>
                              <div className="header_social">
                                    <Social link={social.data || social.facebook === '' ? data.social.facebook : social.facebook} icon={<FaFacebookF/>} bg={`facebook`}/>
                                    <Social link={social.data || social.twitter === '' ? data.social.twitter : social.twitter} icon={<FaTwitter/>} bg={`twitter`}/>
                                    <Social link={social.data || social.instagram === '' ? data.social.instagram : social.instagram} icon={<FaInstagram/>} bg={`instagram`}/>
                                    <Social link={social.data || social.youtube === '' ? data.social.youtube : social.youtube} icon={<FaYoutube/>} bg={`youtube`}/>
                                    <Social link={social.data || social.tiktok === '' ? data.social.tiktok : social.tiktok} icon={<FaTiktok/>} bg={`tiktok`}/>
                                    <Social link={social.data || social.tumblr === '' ? data.social.tumblr : social.tumblr} icon={<FaTumblr/>} bg={`tumblr`}/>
                                    <Social link={social.data || social.discord === '' ? data.social.discord : social.discord} icon={<FaDiscord/>} bg={`discord`}/>
                              </div>
                        </div> 
                  </div>
            </div>
      )
}

export default Header;